const Grid: FC = ({ children }) => (
  <div className="grid grid-flow-col grid-cols-minmax items-center justify-between gap-4">
    {children}
  </div>
);

export default Grid;
